import restService from "@/services/restService";

export class CommonService {
  restService = restService;
}
